import NormalSlider from "../../ui/slider/normalslider/normalSlider";
import React, {useRef, useState} from "react";
import {SwiperRef} from "swiper/react/swiper-react";
import {SliderAdCard} from "../../modals/types/slideradcard";
import Button from "../../core/button/button";
import "../styles/login.scss";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Timer from "../../ui/timer/timer";
import {POST} from "../../api/apiHandler";
import {useNavigate} from "react-router-dom";

interface ILogin {
    step: number
    setStep: React.Dispatch<React.SetStateAction<number>>
}

const Login = ({step, setStep}: ILogin) => {
    const sliderRef = useRef<SwiperRef>(null);
    const sliderItems: SliderAdCard[] = [
        {
            image: require("../../assets/images/icons/Trumpet.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        },
        {
            image: require("../../assets/images/icons/Rocket.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        }, {
            image: require("../../assets/images/icons/Trumpet.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        },
        {
            image: require("../../assets/images/icons/Rocket.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        }, {
            image: require("../../assets/images/icons/Trumpet.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        },
        {
            image: require("../../assets/images/icons/Rocket.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        },
        {
            image: require("../../assets/images/icons/Trumpet.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        }, {
            image: require("../../assets/images/icons/Rocket.png"),
            title: "تبلیغات در تی وی",
            body: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است"
        },
    ]
    const [numberValue, setNumberValue] = useState("");
    const [verificationDigit1, setVerificationDigit1] = useState("");
    const [verificationDigit2, setVerificationDigit2] = useState("");
    const [verificationDigit3, setVerificationDigit3] = useState("");
    const [verificationDigit4, setVerificationDigit4] = useState("");
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const renderSliderItems = (sliderItems: SliderAdCard[]): JSX.Element[] => {
        let allItems: JSX.Element[] = [];
        sliderItems.map((sliderItem, index) => {
            allItems.push(
                <div key={index} className="Login-Slider-Item-Box">
                    <img src={sliderItem.image} alt="" className="img-fluid Login-Slider-Item-Box-Image"/>
                    <h6 className="Login-Slider-Item-Box-Title">{sliderItem.title}</h6>
                    <p className="Login-Slider-Item-Box-Body">{sliderItem.body}</p>
                </div>
            )
            return (
                <></>
            );
        })
        return allItems;
    }
    const time = new Date();
    time.setSeconds(time.getSeconds() + 300);
    const navigate = useNavigate();
    const stepLogin = (): JSX.Element => {
        if (step === 0) {
            return (
                <div className="Step0">
                    <img src={require("../../assets/images/Logo.png")} alt="" className="img-fluid"/>
                    <h3>ورود و ثبت نام</h3>
                    <p>شماره موبایل خود را وارد کنید.</p>
                    <input value={numberValue} onChange={e => setNumberValue(e.target.value)} type="tel" name="mobile"
                           id="mobile" placeholder="شماره موبایل"/>
                </div>
            );
        } else if (step === 1) {
            return (
                <div className="Step1">
                    <h3>کد تأیید را وارد کنید</h3>
                    <p>کد تایید برای شماره {numberValue} ارسال شد</p>
                    <div>
                        <input onKeyUp={e => {
                            const target = e.target as HTMLInputElement;
                            verificationDigit4.length === 1 ? document.getElementById("verificationDigit4")?.focus() : document.getElementById("verificationDigit4")?.focus()
                        }} type="tel" maxLength={1} value={verificationDigit4}
                               onChange={e => setVerificationDigit4(e.target.value)} name="verificationDigit4"
                               id="verificationDigit4"/>
                        <input onKeyUp={e => {
                            const target = e.target as HTMLInputElement;
                            verificationDigit3.length === 1 ? document.getElementById("verificationDigit4")?.focus() : document.getElementById("verificationDigit3")?.focus()
                        }} type="tel" maxLength={1} value={verificationDigit3}
                               onChange={e => setVerificationDigit3(e.target.value)} name="verificationDigit3"
                               id="verificationDigit3"/>
                        <input onKeyUp={e => {
                            const target = e.target as HTMLInputElement;
                            verificationDigit2.length === 1 ? document.getElementById("verificationDigit3")?.focus() : document.getElementById("verificationDigit2")?.focus()
                        }} type="tel" maxLength={1} value={verificationDigit2}
                               onChange={e => setVerificationDigit2(e.target.value)} name="verificationDigit2"
                               id="verificationDigit2"/>
                        <input onKeyUp={e => {
                            const target = e.target as HTMLInputElement;
                            verificationDigit1.length === 1 ? document.getElementById("verificationDigit2")?.focus() : document.getElementById("verificationDigit1")?.focus()
                        }} type="tel" maxLength={1} value={verificationDigit1}
                               onChange={e => setVerificationDigit1(e.target.value)} name="verificationDigit1"
                               id="verificationDigit1"/>
                    </div>
                </div>
            );
        } /*else if (step === 2) {
            return (
                <div className="Step2">
                    <h3>تکمیل ثبت نام</h3>
                    <p>برای تکمیل ثبت نام اطلاعات خود را وارد کنید.</p>
                    <input value={name} onChange={e => setName(e.target.value)} type="text" name="name"
                           id="name" placeholder="نام"/>
                    <input value={lastName} onChange={e => setLastName(e.target.value)} type="text" name="lastName"
                           id="lastName" placeholder="نام خانوادگی"/>
                </div>
            );
        }*/ else {
            return <></>
        }
    }
    return (
        <>
            <div className="Login">
                <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 mb-3">
                        {stepLogin()}
                        <Button type={"primary"} action={() => {
                            if (numberValue.length !== 11) {
                                toast.error('! شماره موبایل اشتباه می باشد ', {
                                    position: "bottom-left",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            } else {
                                if (step === 0) {
                                    setStep(step + 1);
                                } else if (step === 1) {
                                    localStorage.setItem('loggedIn', 'true');
                                    localStorage.setItem('userType', 'user');
                                    navigate("/user/dashboard")
                                }
                            }
                        }} responsive={false}>
                            {
                                step === 0 ?
                                    `ورود ←`
                                    :
                                    step === 2 ?
                                        `ورود ←`
                                        :
                                        `ادامه ←`
                            }
                        </Button>
                        {
                            step === 1 ?
                                <Timer expiryTimestamp={time}/>
                                :
                                null
                        }
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 mb-3 position-relative">
                        <NormalSlider sliderItems={renderSliderItems(sliderItems)} desktopCount={1} tabletCount={1}
                                      mobileCount={1}
                                      reference={sliderRef}/>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default Login